export const listPoliticas = [
  { id: "politicaPrivacidade", name: "Política de Privacidade", link: "https://drive.google.com/file/d/1XYvWwoffHVS3c-dvK3xQ5FZ8bAyNV_Dw/view" },
  {
    id: "termoDeAdesao", name: "Termo de Adesão e <br /> Uso da conta Planium Bank", link: "/nossostermos"
  },
  { id: "aberturaDeConta", name: "Abertura de conta", link: "https://drive.google.com/file/d/1-atIyq49vjuvovxjGRUbzeEeLIP0NNHw/view" },

]